import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Folk } from '@ascschool/model/school/folk.model';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { FolkService } from '@ascschool/services/school/folk.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { NzTableSortFn } from 'ng-zorro-antd/table';
import { PopupThongBaoComponent } from './popup-thong-bao/popup-thong-bao.component';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { map } from 'rxjs/operators';
import { AnnounceService } from '@ascschool/services/user/announce.service';
import { PopupUnViewThongBaoComponent } from './popup-unview-thong-bao/popup-unview-thong-bao.component';
import { PopupViewThongBaoComponent } from './popup-view-thong-bao/popup-view-thong-bao.component';
import { PopupXemNoiDungThongBaoComponent } from './popup-view-noi-dung-thong-bao/popup-view-noi-dung-thong-bao.component';
import { JwtHelperService } from '@auth0/angular-jwt';
@Component({
  selector: 'app-thong-bao',
  templateUrl: './thong-bao.component.html',
  styleUrls: ['./thong-bao.component.scss']
})
export class ThongBaoComponent implements OnInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  heightModal: string;
  widthModal: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  get breadcrumbs(): string[] {
    return ['Hành chính điện tử'];
  }
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    private provinceService: ProvinceService,
    private soGDService: DepartmentOfEducationAndTrainingService,
    private schoolService: SchoolService,
    private authQuery: AuthQuery,
    public utilService: UtilsService,
    private service: AnnounceService
  ) { }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  currentUser: any;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  dataList: any;
  width: number;
  numberControl: number;
  createByName: string;
  private elementPageHeaderTable: ElementRef;
  getProvinceACFn: (value: any) => Observable<any>;
  provinceSubscription: any;
  provinceControl = new FormControl();

  getSchoolACFn: (value: any) => Observable<any>;
  schoolSubscription: any;
  schoolControl = new FormControl();

  getSoGDACFn: (value: any) => Observable<any>;
  SoGDSubscription: any;
  SoGDControl = new FormControl();
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  uid: any;
  sortFn: NzTableSortFn = (a, b) => a.folkName.localeCompare(b.folkName);
  ngOnInit() {

    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.loadProvince();
    this.reload();
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataList = [];
    this.service.getAnnounce(this.commonFilter).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = response && response.rowCount ? response.rowCount : 0;
        this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
        _this.dataList = list ? list : [];
        _this.loading = false;
      },
      (err: any) => {
        _this.dataList = [];
        _this.loading = false;
      }
    );
  } 
  search() {
    this.commonFilter.PageIndex = 1;
    if (this.commonFilter.FromDate) {
      this.commonFilter.FromDate = this.utilService.stringDate(this.commonFilter.FromDate);
    }else{
      this.commonFilter.FromDate = '';
    }
    if (this.commonFilter.ToDate) {
      this.commonFilter.ToDate = this.utilService.stringDate(this.commonFilter.ToDate);
    }else{
      this.commonFilter.ToDate = '';
    }
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.Add(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm() {
    this.commonFilter.Title = '';
    this.commonFilter.FromDate = '';
    this.commonFilter.ToDate = '';
    this.commonFilter.ExpirationStatus = null;
    this.commonFilter.ViewStatus = null;
    this.commonFilter.AnnounceType = null;
    this.reload();
   }
  //popup
  showPopup(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Thông tin thông báo';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupThongBaoComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal
      },
      nzComponentParams: {
        value: item
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  Add() {
    this.showPopup(null);
  }
  Edit(item: any) {
    this.showPopup(item);
  }
  showPopupView(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Thông tin người dùng đã xem thông báo';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupViewThongBaoComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal
      },
      nzComponentParams: {
        value: item
      },
      nzWidth: 1300,
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  showPopupUnView(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Thông tin người dùng chưa xem thông báo';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupUnViewThongBaoComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal
      },
      nzComponentParams: {
        value: item
      },
      nzWidth: 1300,
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  showXemNoiDungThongBao(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Chi tiết thông báo';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupXemNoiDungThongBaoComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.heightModal,
        maxheight: this.heightModal
      },
      nzComponentParams: {
        value: item
      },
      nzWidth: 1300,
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  showDelete(item): void {
    const dialogRef = this.modalService.create({
      nzTitle: 'Xóa thông báo',
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: item.title
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    dialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.service.deleteAnnounce(item.id).subscribe((res: any) => {
          this.utilService.notifyResponse(res);
          this.reload();
        });
      }
    });
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({ ProvinceName: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.provinceSubscription) {
      this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
      });
    }
  }

  changeProvince(control: FormControl) {
    if (control.value) {
      this.provinceControl = control;
      this.loadSoGD();
      this.SoGDControl.setValue(null);
      this.schoolControl.setValue(null);
      if (this.currentUser.accountType === 5 || this.currentUser.accountType === 6) {
        this.loadSchool();
      }
      if (this.currentUser.accountType === 1) {
        this.commonFilter.subordinateTypeId = this.currentUser.eadId;
        this.loadSchool();

      } else {
        if (this.SoGDControl.value) {
          this.commonFilter.subordinateTypeId = this.SoGDControl.value.id;
          this.loadSchool();

        } else {
          this.commonFilter.subordinateTypeId = 0;
          this.loadSchool();

        }
      }
    }
  }

  loadSoGD() {
    this.getSoGDACFn = (value: any) => this.soGDService.getSelectPagingByUserLogin({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SoGDSubscription) {
      this.SoGDSubscription = this.SoGDControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'subordinateTypeId', this.SoGDControl.value);
      });
    }
  }
  changeSoGD(control: FormControl) {
    if (control) {
      this.SoGDControl = control;
      this.loadSchool();
      this.schoolControl.setValue(null);
    }
  }
  loadSchool() {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), SubordinateTypeId: this.commonFilter.subordinateTypeId, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.schoolSubscription) {
      this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
      });
    }
  }

  changeSchool(control: FormControl) {
    this.schoolControl = control;
  }
  handlerResizePopup() {
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height = this.heightModal;
    let top = 30;
    if (this.isResizdePopup === true) {
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: {
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
}
